<template>
  <div class="header-holder">
    <v-app-bar
        class="appBar"
        fixed
        color="headerToolbar accent-4"
        scroll-target="#scrolling-techniques-6"

    >
      <div class="btnIcon">
        <button
            v-if="authState"
            @click.stop="drawer = !drawer"
        >
          <svg-sprite width="20" height="20" :icon-id="drawer ? 'close': 'menu'"></svg-sprite>
        </button>
	      <div class="dot" v-if="isViewDot()"></div>
      </div>
      <div v-once class="logoBlock">
<!--        <router-link to="/profile"></router-link>-->
	      <a class="pc" href="https://fleet.care/" target="_blank">
		      <div v-if="$inWindow(DATE.WINTER)" class="cHead">
			      <svg-sprite width="80" height="80" icon-id="cHead"></svg-sprite>
		      </div>
		      <svg-sprite width="130" height="31" icon-id="logo"></svg-sprite>
		      <div v-if="$inWindow(DATE.HALLOWEEN)"  class="witch">
			      <svg-sprite width="44" height="44" icon-id="witch" halloween></svg-sprite>
		      </div>
	      </a>
	      <a class="mob" href="https://fleet.care/" target="_blank">
		      <div v-if="$inWindow(DATE.WINTER)" class="cHead">
			      <svg-sprite width="80" height="80" icon-id="cHead"></svg-sprite>
		      </div>
		      <svg-sprite width="29" height="30" icon-id="logoMob"></svg-sprite>
	      </a>
	      <div v-if="$inWindow(DATE.HALLOWEEN)">
		      <div class="iconH">
			      <svg-sprite width="44" height="44" icon-id="pumpkin-cat" halloween></svg-sprite>
		      </div>
	      </div>
      </div>

	    <template v-if="isAccountUser">
		    <router-link class="linkBr" to="/account#tabUsers">
			    <custom-btn
					    v-if="isNotAllUsersComments()"
					    text="Back"
					    custom-class="apply btnBrBack"
					    is-all-elements
					    is-extended
					    margin='0'
					    :icon-attrs="{width: 20, height: 20, iconId: 'previous'}"
			    ></custom-btn>
		    </router-link>
		    <router-link class="linkBr" to="/account">
			    <custom-btn
					    text="My Account"
					    custom-class="warning btnBrAccount myAccount"
					    is-all-elements
					    is-extended
					    margin='0'
					    :icon-attrs="{width: 20, height: 20, iconId: 'icon-user'}"
			    ></custom-btn>
		    </router-link>
	    </template>
      <div v-else class="breadcrumbs" v-html="breadcrumbs"></div>

      <v-spacer></v-spacer>
      <div v-if="authState" class="headerRight">
	      <template v-if="isAccountUser">
		      <div v-if="userName" class="userName">
			      <div class="text">{{ userName }}</div>
		      </div>
	      </template>
	      <tool-tip
			      custom-class="headThemeVersion"
			      text="View changes"
			      :position="{ bottom: 'bottom' }"
	      >
		      <v-btn text @click="onUpdateInfoPopup" x-small>v.{{ getVersion.version }}</v-btn>
	      </tool-tip>

	      <tool-tip
			      v-if="accountCountVacation > 0 && role === 3"
			      text="New request vacation"
			      :position="{ bottom: 'bottom' }"
	      >
		      <router-link :to="'/account#tabVacation'">
			      <v-btn icon>
				      <svg-sprite width="22" height="22" icon-id="Umbrella"></svg-sprite>
				      <v-badge color="pink" :content="accountCountVacation"></v-badge>
			      </v-btn>
		      </router-link>
	      </tool-tip>

	      <tool-tip
			      v-if="accountCountNotes > 0 && role === 3"
			      text="New users comments"
			      :position="{ bottom: 'bottom' }"
	      >
		      <router-link :to="'/account#tabAllUsersComments'">
			      <v-btn icon>
				      <svg-sprite width="22" height="22" icon-id="icon-comments"></svg-sprite>
				      <v-badge color="pink" :content="accountCountNotes"></v-badge>
			      </v-btn>
		      </router-link>
	      </tool-tip>

	      <tool-tip
			      custom-class="headThemeSettings"
			      text="Theme settings"
			      :position="{ bottom: 'bottom' }"
	      >
		      <theme-toggle></theme-toggle>
	      </tool-tip>

	      <tool-tip
			      text="Feedback"
			      :position="{ bottom: 'bottom' }"
	      >
		      <v-btn icon @click="onFeedBack(true)" type="button">
			      <v-icon>mdi-message-processing-outline</v-icon>
		      </v-btn>
	      </tool-tip>

	      <tool-tip
			      text="User account"
			      :position="{ bottom: 'bottom' }"
	      >

		      <v-btn icon @click="toProfile" type="button">
			      <div class="avatarWrap">
				      <template v-if="getPhoto && isValid">
					      <v-avatar>
						      <img :src="getPhoto" alt="" @error="onError">
					      </v-avatar>
					      <template v-if="$inWindow(DATE.HALLOWEEN)">
						      <spider-halloween/>
					      </template>
					      <template v-if="$inWindow(DATE.WINTER)">
						      <avatar-christmas/>
					      </template>
				      </template>

				      <template  v-else >
					      <template v-if="$inWindow(DATE.HALLOWEEN)">
						      <svg-sprite width="38" height="38" icon-id="pumpkin-halloween" halloween></svg-sprite>
					      </template>
					      <svg-sprite v-else width="22" height="22" icon-id="user"></svg-sprite>
				      </template>

			      </div>
		      </v-btn>
	      </tool-tip>

	      <div v-if="$inWindow(DATE.HALLOWEEN)">
		      <ghost/>
	      </div>

      </div>
    </v-app-bar>

<!--	  модалка меню-->
	  <v-navigation-drawer v-model="drawer" absolute bottom temporary class="navigation-wrap" :dark="isDarkTheme">
		  <v-list nav dense>
			  <v-list-item-group v-model="group" active-class="deep-green--text">
				  <router-link
						  v-for="item in navLinks"
						  :is="item.disabled ? 'span' : 'router-link'"
						  :key="item.title"
						  :to="item.link ? item.link : ''"
						  link
						  @click="logout"
				  >
					  <v-list-item v-if="!item.child">
						  <div class="icon">
							  <svg-sprite width="20" height="20" :icon-id="item.icon"></svg-sprite>
						  </div>
						  <v-list-item-title>
							  <div class="text">{{ item.title }}
								  <div class="countDot" v-if="isViewDotMinu(item)"></div>
							  </div>
						  </v-list-item-title>

					  </v-list-item>
					  <v-list-group v-else no-action>
						  <template v-slot:activator>
							  <div class="icon">
								  <svg-sprite width="20" height="20" :icon-id="item.icon"></svg-sprite>
							  </div>
							  <v-list-item-title>
								  <div class="text">{{ item.title }}</div>
							  </v-list-item-title>
						  </template>
						  <router-link
								  v-for="i in item.child"
								  :key="i.title"
								  :to="i.link"
								  link
						  >
							  <v-list-item>
								  <v-list-item-title
										  class="ml-4"
										  v-text="i.title"
								  ></v-list-item-title>
							  </v-list-item>
						  </router-link>
					  </v-list-group>
				  </router-link>
			  </v-list-item-group>
		  </v-list>

		  <v-list nav dense>
			  <v-list-item-group v-model="group" active-class="deep-green--text">

					  <v-list-item
							  class="menuThemeSettings"
					  >
						  <theme-toggle></theme-toggle>
						  <v-list-item-title>
							  <div class="text">Theme settings</div>
						  </v-list-item-title>
					  </v-list-item>

					  <v-list-item
					    class="menuThemeVersion"
					  >
						  <v-list-item-title>
							  <div class="text"><v-btn text @click="onUpdateInfoPopup" x-small>v.{{ getVersion.version }}</v-btn></div>
						  </v-list-item-title>
					  </v-list-item>

			  </v-list-item-group>
		  </v-list>
	  </v-navigation-drawer>

<!--	  модалка меню-->

	  <feed-back
        v-if="isFeedBack"
        @updateFeedback="onFeedBack(false)"
    ></feed-back>
    <update-info-popup
        v-if="isUpdateInfoPopup && getVersion"
        @updateInfo="onCloseInfo"
        :version="getVersion"
        :versionShow="getVersionShow"
    ></update-info-popup>

	  <notification-dialog
			  v-if="isNotificationPopup && getNotification"
			  @updateInfo="onCloseNotification"
			  :item="getNotification"
			  :itemShow="getNotificationShow"
	  />

    <preload v-if="preloader"></preload>
  </div>
</template>
<script>
// vuex
import { mapActions, mapGetters } from "vuex";
// components
import ToolTip from "@/shared/ToolTip/ToolTip";
// async components
const UpdateInfoPopup = () => import("@/shared/HeaderComponent/UpdateInfoPopup/UpdateInfoPopup");
const FeedBack = () => import("@/shared/HeaderComponent/FeedBack/FeedBack");
// shared
import Preload from "@/shared/Preload/Preload";
// constants
import routeSetting from "@/router/routeSetting";
// services
import { getAppUrl } from "@/services";
import ThemeToggle from "@/shared/ThemeToggle/ThemeToggle.vue";
import ghost from "@/shared/Halloween/ghost.vue";
import { DATE } from "@/constants/date";
import SpiderHalloween from "@/shared/Halloween/spider-halloween.vue";
import AvatarChristmas from "@/shared/Christmas/AvatarChristmas.vue";
import NotificationDialog from "@/shared/HeaderComponent/NotificationDialog/NotificationDialog.vue";

export default {
	name: "HeaderComponent",
	components: {
		NotificationDialog,
		AvatarChristmas,
		SpiderHalloween,
		ghost,
		ThemeToggle,
		UpdateInfoPopup,
		FeedBack,
		Preload,
		ToolTip
	},
	props: {
		authState: Boolean,
		permissionsListDefault: Array
	},
	inject: [ 'themeIsDark' ],
	computed: {
		...mapGetters([ 'token', 'profileImage', 'role', 'accountCountNotes', 'accountCountVacation', 'userProfile_user' ]),
		isDarkTheme() {
			// если provide вернул функцию — вызываем её
			if (typeof this.themeIsDark === 'function') {
				return !!this.themeIsDark();
			}

			// если вдруг где-то будет просто boolean — тоже приведём к Boolean
			return !!this.themeIsDark;
		},
		getPhoto() {
			if (this.profileImage) {
				return getAppUrl + this.profileImage;
			}

			return '';
		},
		getVersion() {
			return JSON.parse(localStorage.getItem('version')) || {};
		},
		getVersionShow() {
			return JSON.parse(localStorage.getItem('version_show'));
		},
		getVersionShowPopup() {
			return JSON.parse(localStorage.getItem('versionShowPopup'));
		},
		getNotification() {
			return JSON.parse(localStorage.getItem('notification')) || {};
		},
		getNotificationShow() {
			return JSON.parse(localStorage.getItem('notification_show'));
		},
		getNotificationShowPopup() {
			return JSON.parse(localStorage.getItem('notificationShowPopup'));
		}
	},

	data: () => ({
		DATE,
		breadcrumbs: '',
		isAccountUser: false,
		isUpdateInfoPopup: false,
		isNotificationPopup: false,

		isFeedBack: false,
		collapseOnScroll: true,
		isLogin: false,
		drawer: false,
		group: null,
		permissions: [],
		navLinks: [],
		preloader: false,
		isValid: true,
		countNotes: null,
		lastActiveTab: null,
		userName: null,
	}),
	methods: {
		...mapActions([ 'onLogout', 'onVersion', 'onNotification', 'getCountNotes' ]),
		isNotAllUsersComments() {
			this.lastActiveTab = localStorage.getItem('lastActiveTab');
			return this.lastActiveTab !== 'tabAllUsersComments';
		},
		isViewDot() {
			const role = this.role;
			const notes = this.accountCountNotes;
			const vacation = this.accountCountVacation;
			const status =
					(role === 3 && notes > 0)
					|| (role === 3 && vacation > 0);
			return status;
		},
		isViewDotMinu({ title }) {
			const role = this.role;
			const notes = this.accountCountNotes;
			const vacation = this.accountCountVacation;
			const status =
					(title === "Account" && role === 3 && notes > 0)
					|| (title === "Account" && role === 3 && vacation > 0);
			return status;
		},
		onError() {
			this.isValid = false;
		},
		toProfile() {
			// const url = this.isCustomers ? '/profile' : '/account';

			if (this.$route.path !== '/') {
				this.$router.push('/');
			}
		},

		onNotificationPopup() {
			this.isNotificationPopup = true;
		},
		onUpdateInfoPopup() {
			this.isUpdateInfoPopup = true;
		},
		onFeedBack(value) {
			this.isFeedBack = value;
		},
		async onCloseInfo(isCheckbox) {
			this.isUpdateInfoPopup = false;
			localStorage.setItem("versionShowPopup", "false");

			if (isCheckbox) {
				await this.onVersion();
				localStorage.setItem('version_show', "false");
			}
		},
		async onCloseNotification(isCheckbox) {
			this.isNotificationPopup = false;
			localStorage.setItem("versionShowPopup", "false");

			if (isCheckbox) {
				const id = this.getNotification.id;
				await this.onNotification(id);
				localStorage.setItem('version_show', "false");
			}
		},
		async logout() {
			this.preloader = true;
			await this.onLogout();
			await this.$router.push({ path: "/auth" });
			this.preloader = false;
		},
		recFilter(obj1, obj2) {
			const objDef = Object.assign({}, obj1);
			const objSearch = Object.assign({}, obj2);
			if (objDef && objSearch && !objDef.child) {
				if (objSearch.selected) return objDef;

			} else if (objDef && objSearch && objDef.child) {
				if (objSearch.selected) {
					const arr = [];
					for (const i of objDef.child) {
						const obj = objSearch.children.find((o) => o.name === i.title);
						if (obj) {
							const r = this.recFilter(i, obj);
							if (r) arr.push(r);
						} else {
							arr.push(i);
						}
					}
					objDef.child = arr;
					return objDef;
				}

			}
		},
		setLink(permissions) {
			const arr = [];
			for (const i of routeSetting) {
				const obj = permissions?.find((value) => value.name === i.title);
				if (obj) {
					const a = this.recFilter(i, obj);
					if (a) arr.push(a);
				} else {
					const obji = Object.assign({}, i);
					arr.push(obji);
				}
			}
			return arr;
		},
		getAccountUser(route) {
			const { routeNames } = route.meta;
			const { name } = route;
			this.isAccountUser = routeNames && name === 'User';
			this.lastActiveTab = localStorage.getItem('lastActiveTab');
			this.userName = null;
		},
		getBreadcrumbs(route) {
			const routeNames = route?.meta?.routeNames;

			if (Array.isArray(routeNames) && routeNames.length > 1) {
				this.breadcrumbs = routeNames.reduce((acc, item, idx) => (
					acc += !idx ? `<span>${ item }</span>` : `  ›   <span>${ item }</span>`
				), '');
			} else if (Array.isArray(routeNames)) {
				const [ item = '' ] = routeNames;
				this.breadcrumbs = `<span>${ item }</span>`;
			} else {
				this.breadcrumbs = '';
			}
		},
	},
	created() {

		if (this.getVersionShow && this.getVersionShowPopup) {
			this.isUpdateInfoPopup = true;
		}
		if (this.getNotificationShow && this.getNotificationShowPopup) {
			this.isNotificationPopup = true;
		}

		this.isLogin = this.authState;
		this.permissions = this.permissionsListDefault;
		this.navLinks = this.setLink(this.permissionsListDefault);

		this.getBreadcrumbs(this.$route);
		this.getAccountUser(this.$route);
		this.getCountNotes();

	},
	watch: {
		userProfile_user(val, oldVal) {
			if (val !== oldVal) {
				this.userName = val.name;
			}
		},
		profileImage(val, oldVal) {
			if (val !== oldVal) {
				this.isValid = true;
			}
		},
		permissionsListDefault(val) {
			if (val) {
				this.navLinks = this.setLink(val);
			}
		},
		isLogin(val) {
			if (!val) this.navLinks = [];
		},
		$route(to) {
			this.getBreadcrumbs(to);
			this.getAccountUser(to);
		}
	},
};
</script>

<style lang="scss">
@import "HeaderComponentAll";

.headThemeVersion,
.headThemeSettings {
	@media screen and (max-width: 768px) {
		display: none;
	}
}
.menuThemeVersion,
.menuThemeSettings {
	display: none;
	@media screen and (max-width: 768px) {
		display: flex;
	}
}
</style>

<style lang="scss" scoped>
@import "HeaderComponent";
</style>
